<div class="d-flex">
	<div class="mx-2 h3">{{ promoCodeSelected.promoCode || "New Promo Code" }}</div>
	<p-inputSwitch styleClass="ms-3 mt-1" name="promoCodeActiveSelect" binary="true" [(ngModel)]="promoCodeSelected.active" label="Active"></p-inputSwitch>
</div>
<p-divider></p-divider>
<div class="p-grid">
	<div class="p-col-12 p-md-4 d-flex flex-column">
		<span class="p-float-label mt-2">
			<input
				pInputText
				#promoCodeName
				name="promoCodeName"
				[formControl]="controlPromoCodeCode"
				type="text"
				[(ngModel)]="promoCodeSelected.promoCode"
				class="w-100"
			/>
			<label for="promoCodeName">Promo Code</label>
		</span>
		<div *ngIf="controlPromoCodeCode.errors" class="alert-danger text-center">
			<div *ngIf="controlPromoCodeCode.hasError('required')">Promo code name is required</div>
			<div *ngIf="controlPromoCodeCode.hasError('duplicateValue')">
				The promo code {{ promoCodeSelected.promoCode }} is already in use. Please enter another
			</div>
		</div>
		<span class="p-float-label mt-4">
			<input pInputText #displayName name="displayName" type="text" [(ngModel)]="promoCodeSelected.displayName" class="w-100" />
			<label for="promoCodeName">Display Name</label>
		</span>
		<span class="p-float-label mt-4">
			<p-inputNumber
				#promoCodeValueInput
				[formControl]="controlPromoCodeValue"
				min="1.00"
				[(ngModel)]="promoCodeSelected.value"
				inputId="currency-us"
				mode="currency"
				currency="USD"
				locale="en-US"
				styleClass="w-100"
			></p-inputNumber>
			<label for="promoCodeValueInput">Promo Code Value</label>
		</span>
		<div *ngIf="controlPromoCodeValue.errors" class="alert-danger text-center">
			<div *ngIf="controlPromoCodeValue.hasError('required')">Promo code value is required.</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4 d-flex flex-column">
		<span class="p-float-label mt-2">
			<p-multiSelect
				#promoCodeTransactionTypes
				[options]="transactionTypes"
				optionLabel="label"
				optionValue="value"
				name="transactionTypes"
				[(ngModel)]="promoCodeSelected.types"
				[style]="{ width: '100%' }"
				appendTo="body"
				autoDisplayFirst="false"
			></p-multiSelect>
			<label for="promoCodeTransactionTypes">Transaction Types</label>
		</span>
	</div>
	<div class="p-col-12 p-md-4 d-flex flex-column">
		<span class="p-float-label mt-2">
			<p-dropdown
				#promoCodeMenuItemKey
				[options]="venueSvc.ooMenuItems"
				optionLabel="name"
				optionValue="menuItemKey"
				name="promoCodeMenuItemKey"
				[(ngModel)]="promoCodeSelected.menuItemKey"
				[style]="{ width: '100%' }"
				appendTo="body"
				autoDisplayFirst="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				filterBy="name"
			>
			</p-dropdown>
			<label for="promoCodeMenuItemKey">POS Menu Item</label>
		</span>
	</div>
</div>

<div class="p-grid">
	<div class="p-col-12 p-md-4 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">Item Requirements</div>
		</div>
		<p-divider></p-divider>
		<span class="p-float-label">
			<p-multiSelect
				#requiredMenuItemKeysSelect
				[options]="venueSvc.ooMenuItems"
				optionLabel="name"
				optionValue="menuItemKey"
				name="venueSvc.ooMenuItems"
				[(ngModel)]="promoCodeSelected.requiredMenuItemKeys"
				[style]="{ width: '100%' }"
				appendTo="body"
				autoDisplayFirst="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				filterBy="name,menuItemKey"
			></p-multiSelect>
			<label for="requiredMenuItemKeysSelect">Required Menu Items</label>
		</span>
		<div class="descriptionText">
			These menu items are required to be on the order for this promo code to work. <i>Does not apply to promo codes used for eGift</i>
		</div>
	</div>

	<div class="p-col-12 p-md-4 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">Applicable Items</div>
		</div>
		<p-divider></p-divider>
		<span class="p-float-label">
			<p-multiSelect
				#applicableMenuItemKeysSelect
				[options]="venueSvc.ooMenuItems"
				optionLabel="name"
				optionValue="menuItemKey"
				name="venueSvc.ooMenuItems"
				[(ngModel)]="promoCodeSelected.applicableMenuItemKeys"
				[style]="{ width: '100%' }"
				appendTo="body"
				autoDisplayFirst="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				filterBy="name,menuItemKey"
			></p-multiSelect>
			<label for="applicableMenuItemKeysSelect">Applicable Items</label>
		</span>
		<div class="descriptionText">The promo code will be multiplied across these items. <i>Does not apply to promo codes used for eGift</i></div>
	</div>
	<div class="p-col-12 p-md-4 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">Available Days</div>
		</div>
		<p-divider></p-divider>
		<span class="p-float-label mt-2">
			<p-multiSelect
				#availableDaySelect
				[options]="app.references.daysOfWeek"
				optionLabel="label"
				optionValue="value"
				[(ngModel)]="promoCodeSelected.availableDays"
				appendTo="body"
				styleClass="w-100"
			>
			</p-multiSelect>
			<label for="availableDaySelect">Available Days</label>
		</span>
		<div class="descriptionText">This Promo Code will only be available on these days.</div>
	</div>
</div>
<div class="p-grid">
	<div class="p-col-12 p-md-4 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">Effective Dates</div>
		</div>
		<p-divider></p-divider>
		<span class="p-float-label mt-2">
			<p-calendar [(ngModel)]="promoCodeSelected.startDateDate" appendTo="body" styleClass="w-100"></p-calendar>
			<label for="startDateSelect">Start Date</label>
		</span>
		<span class="p-float-label mt-4">
			<p-calendar [(ngModel)]="promoCodeSelected.endDateDate" appendTo="body" styleClass="w-100"></p-calendar>
			<label for="startDateSelect">End Date</label>
		</span>
	</div>
	<div class="p-col-12 p-md-4 d-flex flex-column"></div>
	<div class="p-col-12 p-md-4 d-flex flex-column"></div>
</div>
<app-record-control-footer
	(onCancelChange)="promoCodeSelectedChange.emit(undefined)"
	(onSaveChange)="onSave()"
	(onDeleteChange)="onDelete()"
></app-record-control-footer>
